import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_GENERAL_SETTINGS } from '../../routes/Router';

const GeneralSettings = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    return (
        <ActionBarItem id="generalSetting">
            <ActionBarItem.Icon onClick={() => navigate(ROUTE_GENERAL_SETTINGS)}>
                <span
                    className={`icon rioglyph rioglyph-cog  ${pathname.includes(ROUTE_GENERAL_SETTINGS) ? 'text-color-primary' : ''}`}
                />
            </ActionBarItem.Icon>
        </ActionBarItem>
    );
};

export default GeneralSettings;
